import {changeEvent, dispatchCustomEvent, fireChangeEvent} from "../../../../../../../webpack/modules/events";
import {slideDown, slideUp} from "../../../../../../../webpack/modules-optimized/element-visibility";
import {upload} from "../../../../../../../webpack/modules/ajax";
import {isDesktop} from "../../../../../../../webpack/modules/devices";
import {addComplement, removeComplement} from "../../../../../../../webpack/modules-optimized/product-list";

changeEvent('#product-list-page .product-configuration-customizer[data-option-type="selectable"] .custom-file-input', true, function(element, event) {
    let container = element.closest('.input-group');
    let display = container.querySelector('input[type="text"]');
    let input = container.querySelector('input[type="hidden"]');
    let file = event.target.files[0] || null;
    let prefix = element.dataset.prefix;
    let onlyPrintable = element.dataset.onlyPrintable;
    let error = element.closest('.custom-image, #custom-image').querySelector('.error');

    slideUp(error);
    display.value = '';
    input.value = '';
    element.value = null;

    if (!file) return;

    upload(
        file,
        {prefix: prefix, onlyPrintable: onlyPrintable, file: file},
        function(response) {
            display.value = response.fileInfo.originalName;
            input.value = response.fileInfo.file;
            fireChangeEvent(input, true);
        },
        function(errorMessage) {
            error.innerHTML = errorMessage;
            slideDown(error);
        }
    );
});

changeEvent('#product-list-page .product-configuration-customizer[data-option-type="selectable"] input[name="custom-image"]', true, function(element) {
    let configurationMain = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let container = element.closest('.product-configuration');
    let customImage = element.value;
    let customImageText = container.querySelector('input[name="display-custom-image"]').value;
    let customText = container.querySelector('input[name="customText"], textarea[name="customText"]');
    let customImageFromWeb = container.querySelector('input[name="customImageFromWeb"]');
    let previewElement = configurationMain.querySelector('.open-configuration .preview-option-customizer');
    let increment = container.querySelector('input[name="customPriceIncrement"]');
    let optionCustomizer = configurationMain.querySelector('.product-configuration-main input[name="option-customizer"]');
    let optionValue = optionCustomizer.value !== '' ? JSON.parse(optionCustomizer.value) : {};

    dispatchCustomEvent(
        'productCustomImageChanged',
        {
            'option': container,
            'customImageFromWeb': customImageFromWeb,
            'previewElement': previewElement,
            'increment': increment,
        }
    );

    optionValue['customPriceIncrement'] = increment ? increment.checked : false;
    optionValue['personalizedImage'] = customImage;
    optionValue['personalizedImageText'] = customImageText;
    if (customImageFromWeb) optionValue['personalizedImageFromWeb'] = customImageFromWeb.checked;

    if (increment) {
        if (increment.checked) addComplement(increment);
        else removeComplement(increment);
    }

    if (customImage !== '' && (!customText || customText.value !== "")) container.dataset.completed = 'true';
    else container.dataset.completed = 'false';

    optionCustomizer.value = JSON.stringify(optionValue);
    dispatchCustomEvent('productListProductConfigurationChanged');
});

changeEvent('#product-list-page .product-configuration-customizer[data-option-type="selectable"] input[name="customImageFromWeb"]', true, function(element) {
    let configurationMain = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let container = element.closest('.product-configuration');
    let previewElement = configurationMain.querySelector('.open-configuration .preview-option-customizer');
    let increment = container.querySelector('input[name="customPriceIncrement"]');
    let customText = container.querySelector('input[name="customText"], textarea[name="customText"]');
    let optionCustomizer = configurationMain.querySelector('.product-configuration-main input[name="option-customizer"]');
    let optionValue = optionCustomizer.value !== '' ? JSON.parse(optionCustomizer.value) : {};

    dispatchCustomEvent(
        'productCustomImageFromWebChanged',
        {
            'option': container,
            'customImageFromWeb': element,
            'previewElement': previewElement,
            'increment': increment,
            'customImage': container.querySelector('input[name="custom-image"]'),
            'customImageFile': container.querySelector('input[name="file-customImage"]'),
            'customImageDisplay': container.querySelector('input[name="display-custom-image"]'),
            'customText': customText
        }
    );

    optionValue['customPriceIncrement'] = increment.checked;
    optionValue['personalizedImageFromWeb'] = element.checked;
    optionValue['personalizedImage'] = '';
    optionValue['personalizedImageText'] = '';

    if (increment.checked) addComplement(increment);
    else removeComplement(increment);

    if (increment.checked) {
        if (element.checked && (customText && customText.value !== '' || !customText)) container.dataset.completed = 'true';
        else container.dataset.completed = 'false';
    } else {
        if (element.checked && (customText && customText.value === '' || !customText)) {
            if (customText && customText.value === '') optionValue['personalizedText'] = '-';
            container.dataset.completed = 'true';
        } else {
            container.dataset.completed = 'false';
        }
    }

    optionCustomizer.value = JSON.stringify(optionValue);
    dispatchCustomEvent('productListProductConfigurationChanged');
});

changeEvent('#product-list-page .product-configuration-customizer[data-option-type="selectable"] input[name="customPriceIncrement"]', true, function(element) {
    let configurationMain = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let container = element.closest('.product-configuration');

    if (!container.querySelector('input[name="custom-image"]')) return;

    let customImage = container.querySelector('input[name="custom-image"]');
    let customImageFile = container.querySelector('input[name="file-customImage"]');
    let customImageDisplay = container.querySelector('input[name="display-custom-image"]');
    let customImageFromWeb = container.querySelector('input[name="customImageFromWeb"]');
    let customText = container.querySelector('input[name="customText"], textarea[name="customText"]');
    let previewElement = configurationMain.querySelector('.open-configuration .preview-option-customizer');
    let optionCustomizer = configurationMain.querySelector('.product-configuration-main input[name="option-customizer"]');
    let optionValue = optionCustomizer.value !== '' ? JSON.parse(optionCustomizer.value) : {};

    dispatchCustomEvent(
        'productCustomImageIncrementChanged',
        {
            'option': container,
            'previewElement': previewElement,
            'increment': element,
            'customImage': customImage,
            'customImageFile': customImageFile,
            'customImageDisplay': customImageDisplay,
            'customImageFromWeb': customImageFromWeb,
        }
    );

    optionValue['customPriceIncrement'] = element.checked;
    if (customImageFromWeb) optionValue['personalizedImageFromWeb'] = customImageFromWeb.checked;
    optionValue['personalizedImage'] = '';
    optionValue['personalizedImageText'] = '';

    if (element.checked) addComplement(element);
    else removeComplement(element);

    if (!element.checked && customImage.value === '' && (customImageFromWeb && customImageFromWeb.checked) && (customText && customText.value === '' || !customText)) {
        container.dataset.completed = 'true';
    } else {
        container.dataset.completed = 'false';
    }

    optionCustomizer.value = JSON.stringify(optionValue);
    dispatchCustomEvent('productListProductConfigurationChanged');
});

changeEvent('#product-list-page .product-configuration-customizer[data-option-type="selectable"] input[name="complement"][data-type="sample_image"]', true, function(input) {
    if (input.checked) addComplement(input);
    else removeComplement(input);
});